var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"\r\n"}],
    template = twig({"id":"$resolved:b105577812e344add8ffcbf1132ff66decf51936b43043a5858789ae48cee9fe59832958cd44f7b75ce0cf211839e83ac0fd32684cc467c796d83199c1630fbf:subpage.html.twig","data":[{"type":"raw","value":"\r\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;